export const Config = require(`./config.${process.env.REACT_APP_TARGET_ENVIRONMENT}.json`);